var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultProfileImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C21.5228 20 26 15.5228 26 10C26 4.47715 21.5228 0 16 0C10.4772 0 6 4.47715 6 10C6 15.5228 10.4772 20 16 20Z",
    fill: "#BEECE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.021 24H3.979C1.785 24 0 25.785 0 27.979V29.5C0 32.812 1.885 35.676 5.307 37.563C8.154 39.135 11.952 40 16 40C23.706 40 32 36.714 32 29.5V27.979C32 25.785 30.215 24 28.021 24Z",
    fill: "#BEECE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileImg);
export default __webpack_public_path__ + "static/media/default_profile_img.7928860a62c5083067ce916379efb92b.svg";
export { ForwardRef as ReactComponent };